export default "__VITE_ASSET__CUK1Hg78__"